<template>
  <!-- ini adalah card untuk kelas yang harus diselesaikan -->
  <v-card v-if="type == 'enroll'" style="height:100%">
    <div>
      <v-img
        contain
        class="white--text align-end"
        height="200px"
        :src="item.cover ? item.cover : 'https://cdn.siap.id/s3/simpkb/asset img/guru-praktik-baik/bg-success.jpg'"
      ></v-img>
      <div :class="statusJadwal == 'Tryout Selesai' ? 'arrow-left-green' : statusJadwal == 'Sedang Berlangsung' ? 'arrow-left-orange' : 'arrow-left-blue'"></div>
      <div :class="statusJadwal == 'Tryout Selesai' ? 'label-green' : statusJadwal == 'Sedang Berlangsung' ? 'label-orange' : 'label-blue'">
        {{ item.waktu ? statusJadwal : "Dalam Proses" }}
      </div>
      <div class="caption blue--text text--lighten-4 text-right mr-2">{{ ukg }}</div>
    </div>

    <v-card-subtitle class="black--text font-weight-bold mb-0 pb-1">{{ title }} </v-card-subtitle>

    <v-card-subtitle class="black--text my-0 py-0" v-if="item.waktu">
      <v-row>
        <v-col class="mb-0 py-0" cols="1">
          <v-icon size="15" color="primary">mdi-clock-outline</v-icon>
        </v-col>
        <v-col class="my-0 pt-0 body-2" cols="11">
          <span class="font-weight-bold"> {{ pVal(item.waktu, "tanggal") | toD }}</span>
          <p class="mb-0 py-0">Pukul {{ pVal(item.waktu.sesi, "waktu_mulai") | formatTime }} - {{ pVal(item.waktu.sesi, "waktu_selesai") | formatTime }} WIB</p>
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-card-text class="black--text">
      <v-row>
        <v-col class="mb-0 py-0" cols="1">
          <v-icon size="15" class="mt-n1" color="success">mdi-check</v-icon>
        </v-col>
        <v-col class="my-0 pt-0 body-2" cols="11">
          {{ item.kelas.keterangan }}
        </v-col>
        <v-col class="mb-0 py-0" cols="1" v-if="statusJadwal == 'Tryout Selesai'">
          <v-icon size="20" class="mt-n1" color="info">mdi-star</v-icon>
        </v-col>
        <v-col class="mb-0 py-0" cols="11" v-if="statusJadwal == 'Tryout Selesai'">
          <m-chip class="body-1" icon="mdi-refresh" :title="cekNilai" action="updateNilai" @updateNilai="$emit('updateNilai', item.id)"></m-chip>
        </v-col>
      </v-row>
      <p v-if="!item.waktu" class="mt-2 yellow lighten-4 pa-2">Jadwal <i>tryout</i> Anda sedang kami proses dalam kurun waktu maksimal 1x24 jam.</p>
      <!-- <p v-if="!item.waktu" class="mt-2 yellow lighten-4 pa-2">Pendaftaran <i>tryout</i> ditutup.</p> -->
    </v-card-text>

    <v-card-actions class="mt-0 pt-2">
      <v-row>
        <v-col cols="12" class="my-0 py-1">
          <m-button v-if="statusJadwal == 'Tryout Selesai'" isBlock disabled depressed color="success" icon="mdi-link" textButton="Tryout ditutup"></m-button>
          <m-button v-else-if="statusJadwal == 'Belum dibuka'" disabled isBlock depressed color="success" icon="mdi-timelapse" textButton="Belum dibuka"></m-button>
          <m-button
            v-else-if="item.waktu"
            :disabled="!item.kelas_moodle"
            isBlock
            depressed
            color="primary"
            :icon="item.waktu ? 'mdi-link' : 'mdi-timelapse'"
            :textButton="item.kelas_moodle ? 'Tautan Tryout' : 'Tautan dalam proses'"
            action="toLMS"
            @toLMS="toLMS(item.kelas_moodle)"
          ></m-button>
          <m-button v-else disabled isBlock depressed color="primary" icon="mdi-timelapse" textButton="Jadwal dalam proses"></m-button>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
  <!-- ini adalah card untuk kelas yang bisa dipilih -->

  <v-card v-else-if="type == 'pilih' && item.kelas.mapel.is_kejuruan" style="height:100%">
    <div>
      <v-img contain class="white--text align-end" height="200px" src="https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/seri-pppk.png"></v-img>
      <div class="arrow-left-blue"></div>
      <div class="label-blue">
        Tersedia
      </div>
    </div>

    <v-card-subtitle class="black--text font-weight-bold mb-0 pb-1">Tryout {{ mapel }}</v-card-subtitle>

    <v-card-subtitle class="black--text my-0 py-0">
      <v-row>
        <v-col class="mb-0 py-0" cols="1">
          <v-icon size="15" color="primary">mdi-clock-outline</v-icon>
        </v-col>
        <v-col class="my-0 pt-0 body-2" cols="11">
          <span>Dengan <strong>mendaftar</strong>, Anda akan mendapatkan jadwal <i>tryout</i> yang tersedia</span>
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-card-text class="black--text ">
      <v-row>
        <v-col class="mb-0 py-0" cols="1">
          <v-icon size="15" class="mt-n1" color="success">mdi-check</v-icon>
        </v-col>
        <v-col class="my-0 pt-0 body-2" cols="11">
          {{ tahap == 1 ? "Pengerjaan tryout" : "Pengerjaan tryout paket lain" }}
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="mt-0 pt-0">
      <v-row>
        <v-col cols="12" class="my-0 py-1">
          <m-button
            v-if="current_instansi.is_rilis"
            class="my-2"
            :disabled="disabled"
            isBlock
            depressed
            color="primary"
            :textButton="disabled ? 'Pendaftaran ditutup' : 'Daftar Tryout'"
            action="toEnroll"
            @toEnroll="$emit('toEnroll', item)"
          ></m-button>
          <m-button v-else class="my-2" disabled isBlock depressed color="primary" textButton="Pendaftaran belum dibuka"></m-button>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
  <span v-else></span>
</template>

<script>
//@group PPPK Feature
export default {
  name: "tryout-pendaftaran",
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "primary"
    },
    type: {
      type: String,
      default: "pilih"
    },
    isJadwalUlang: {
      type: Boolean,
      default: false
    },
    isModeKelas: {
      type: Boolean,
      default: false
    },
    isSyarat: {
      type: Boolean,
      default: true
    },
    syarats: {
      type: Array,
      default: () => []
    },
    buttonText: {
      type: String,
      default: "Klik"
    },
    serverTime: {
      type: Date,
      default: null
    },
    mapel: {
      type: String,
      default: ""
    },
    tahap: {
      type: Number,
      default: 1
    },
    isRilis: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      cekKuota: null,
      reloadKuota: false,
      t: false,
      panel: [1]
    };
  },
  methods: {
    ubahJadwal(item) {
      this.$emit("ubahJadwal", item);
    },
    reloadKelasku() {
      this.$emit("reload");
    },
    toLMS(val) {
      window.open(val.lms_url, "_blank");
    }
  },
  computed: {
    ukg() {
      var str = this.current_user.email;
      if (str.includes("@guruku.id")) {
        return str.replace("@guruku.id", "");
      }
      return str;
    },
    cekNilai() {
      var nilai = "" + this.item.nilai;
      if (nilai == "null") {
        return "Cek Nilai";
      } else {
        return "Nilai Anda : " + nilai;
      }
    },
    statusJadwal() {
      if (this.item.waktu) {
        var waktuMulai = this.$tools.combineWaktu(this.item.waktu.tanggal, this.item.waktu.sesi.waktu_mulai);
        var waktuSelesai = this.$tools.combineWaktu(this.item.waktu.tanggal, this.item.waktu.sesi.waktu_selesai);
        if (this.$tools.parseIsAfter(this.item.server_time, waktuSelesai)) {
          return "Tryout Selesai";
        } else if (this.$tools.parseIsAfter(this.item.server_time, waktuMulai) && this.$tools.parseIsBefore(this.item.server_time, waktuSelesai)) {
          return "Sedang Berlangsung";
        } else if (this.$tools.toD(this.item.server_time) === this.$tools.toD(waktuMulai)) {
          return "Persiapan Tryout";
        } else if (this.$tools.parseIsBefore(this.item.server_time, waktuMulai)) {
          return "Belum dibuka";
        } else {
          return "";
        }
      } else {
        return "Sedang dijadwalkan";
      }
    },
    disabled() {
      var statusSyarat = [];
      this.syarats.forEach(syarat => {
        statusSyarat.push(syarat.status);
      });
      if (statusSyarat.includes(false)) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style>
.label-blue {
  background-color: #007bff;
  color: white;
  top: 20px;
  left: -20px;
  position: absolute;
  padding: 5px 15px 5px 15px;
  text-align: left;
}

.arrow-left-blue {
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  top: 33px;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 20px solid #007bff;
}

.label-red {
  background-color: #e61d4c;
  color: white;
  top: 20px;
  left: -20px;
  position: absolute;
  padding: 5px 15px 5px 15px;
  text-align: left;
}

.arrow-left-red {
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  top: 33px;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 20px solid rgb(170, 0, 0);
}

.label-green {
  background-color: rgb(61, 187, 82);
  color: white;
  top: 20px;
  left: -20px;
  position: absolute;
  padding: 5px 15px 5px 15px;
  text-align: left;
}

.arrow-left-green {
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  top: 33px;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 20px solid rgb(10, 143, 54);
}

.label-orange {
  background-color: #ff9800;
  color: white;
  top: 20px;
  left: -20px;
  position: absolute;
  padding: 5px 15px 5px 15px;
  text-align: left;
}

.arrow-left-orange {
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  top: 33px;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 20px solid #ff9800;
}

.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 40px;
}
</style>
